module.exports = __webpack_public_path__ + "static/img/BF-sale.92a7f38.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/BF-sale.png
// module id = zcri
// module chunks = 1